exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".btn-default.btn-on.active {\n  background-color: #5BB75B;\n  color: white; }\n\n.btn-default.btn-off.active {\n  background-color: #5BB75B;\n  color: white; }\n\n.bypass-code-date-section {\n  min-width: 15%; }\n\n.minWidth150 {\n  min-width: 150px; }\n\n.margin-bottom-30 {\n  margin-bottom: 30px; }\n\n.bypass-code-section {\n  font-size: 37px;\n  color: #70ad46; }\n\n.bypass-code-title-section {\n  color: black;\n  font-weight: bold; }\n\n.bypass-code-view-section {\n  margin-top: 100px;\n  padding-left: 100px !important; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./client/app/components/branch_management/components/tnt_bypass_code/tnt_bypass_code.scss
// module id = 1015
// module chunks = 1